export enum RugbyUnionDropGoalAttribute {
  Golden = 1067,
}
